// Apolo IDE — LearningPanel Memories sub-tab (WS L6.4).
//
// Lists recently applied memory candidates (status='applied',
// candidate_type='memory') from the Worker. Each row is a link that
// opens the note in Obsidian via the existing IPC bridge.

import { Loader2, ExternalLink } from 'lucide-react';
import { useLearningCandidates } from '../../../../hooks/useLearning.js';

export default function Memories() {
  const { data, loading, error } = useLearningCandidates('applied', { pollIntervalMs: 30_000 });

  function open(path) {
    if (!path) return;
    if (typeof window !== 'undefined' && window.apolo?.openInObsidian) {
      window.apolo.openInObsidian(path).catch(() => {});
    }
  }

  if (loading && !data) {
    return (
      <div className="flex items-center gap-2 p-3 text-[11px] text-apolo-textTertiary" role="status">
        <Loader2 size={12} className="animate-spin" aria-hidden="true" />
        Carregando memories...
      </div>
    );
  }
  if (error) {
    return (
      <div role="alert" className="p-3 text-[11px] text-apolo-error">
        {error}
      </div>
    );
  }

  const candidates = (data?.data?.candidates ?? data?.candidates ?? []).filter(
    (c) => c.candidate_type === 'memory',
  );

  if (candidates.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-1 p-6 text-[11px] text-apolo-textTertiary">
        <p>Nenhuma memory aplicada ainda.</p>
        <p className="text-[10px]">Memories aprovadas viram notas em Sistema/Memory/auto/.</p>
      </div>
    );
  }

  return (
    <ul aria-label="Memories aplicadas" className="flex flex-col gap-2 p-3">
      {candidates.map((c) => (
        <li
          key={c.id}
          className="rounded border border-apolo-borderSubtle bg-apolo-surface2 p-2"
        >
          <p className="text-[11px] text-apolo-textPrimary">{c.summary}</p>
          {c.applied_vault_path && (
            <button
              type="button"
              onClick={() => open(c.applied_vault_path)}
              aria-label={`Abrir ${c.applied_vault_path} no Obsidian`}
              className="mt-1 inline-flex items-center gap-1 text-[10px] text-apolo-accent transition hover:underline"
            >
              <ExternalLink size={10} aria-hidden="true" />
              <span className="truncate" title={c.applied_vault_path}>
                {c.applied_vault_path}
              </span>
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
